import { HttpError } from "./api-client.js";

/** Same budget as the `retry: 1` this replaces, for the failures worth one. */
const MAX_RETRIES = 1;

/**
 * TanStack Query `retry` policy. A 4xx is the API's answer about the request
 * itself — an unknown trace id (404), an expired session (401), a bad param
 * (400) — so re-sending it can't change the outcome; it only holds the view
 * on "Loading…" for the ~1 s retry delay before the not-found / login /
 * error view the user is waiting for. 408 and 429 are the two 4xx that do
 * mean "try again", so they keep the retry. Network errors and 5xx keep it too.
 */
export function shouldRetryQuery(failureCount: number, err: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  if (err instanceof HttpError && err.status >= 400 && err.status < 500) {
    return err.status === 408 || err.status === 429;
  }
  return true;
}
